import { Component, OnInit, Inject, ViewChild, ElementRef, HostBinding } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatSelect } from '@angular/material';
import { ILabelHisItem, ILabelKey } from '../../../../services/eleview/types/model';
import { LabelManagerService } from '../../service/label-manager.service';

export interface LabelHistoryDialogData {
	svr: LabelManagerService;
	data: ILabelKey;
}
@Component({
	selector: 'common-label-history',
	templateUrl: './label-history.component.html',
	styleUrls: ['./label-history.component.scss']
})
export class LabelHistoryComponent implements OnInit {
	@HostBinding('class.label-history') hostClass = true;

	labelHisList: ILabelHisItem[];
	selectedItem: ILabelHisItem;
	whereString: string;
	plainText: string;
	@ViewChild('dialogLabel', { static: true })
	dislogLabel: ElementRef;
	constructor(
		public dialogRef: MatDialogRef<LabelHistoryComponent>,
		@Inject(MAT_DIALOG_DATA) public data: LabelHistoryDialogData
	) {}
	ngOnInit() {
		this.data.svr.backface.fetchLabelHisList(this.data.data).subscribe(v => {
			this.labelHisList = v || [];
			if (this.labelHisList.length > 0) {
				this.selectedItem = this.labelHisList[0];
				this.fetchData(this.labelHisList[0]);
			}
		});
		this.dislogLabel.nativeElement.parentElement.parentElement.style = 'padding:0';
	}
	private fetchData(key: ILabelHisItem) {
		this.data.svr.backface
			.fetchLabelHis({
				CategoryID: this.data.data.CategoryID,
				ID: this.data.data.ID,
				Version: key.Version
			})
			.subscribe(v => {
				this.whereString = v.Conts;
				this.plainText = v.PlainText;
			});
	}
	selectChange(event: MatSelect) {
		this.fetchData(event.value as ILabelHisItem);
		this.selectedItem = event.value as ILabelHisItem;
	}
	close(): void {
		this.dialogRef.close();
	}
}
